import iconSliders from '@phosphor-icons/core/regular/sliders.svg';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useCompose } from '@/hooks/use-compose';
import { useComposeVisibility } from '@/stores/compose';
import { useModalsActions } from '@/stores/modals';

import ComposeFormButton from './compose-form-button';

const messages = defineMessages({
  label: {
    id: 'compose_form.interaction_policy.label',
    defaultMessage: 'Manage interaction policy',
  },
});

interface IInteractionPolicyButton {
  composeId: string;
}

const InteractionPolicyButton: React.FC<IInteractionPolicyButton> = ({ composeId }) => {
  const intl = useIntl();

  const { openModal } = useModalsActions();

  const handleClick = () => {
    openModal('COMPOSE_INTERACTION_POLICY', {
      composeId,
    });
  };

  const { interactionPolicy } = useCompose(composeId);
  const visibility = useComposeVisibility(composeId);

  if (!['public', 'unlisted', 'private'].includes(visibility)) return null;

  return (
    <ComposeFormButton
      icon={iconSliders}
      title={intl.formatMessage(messages.label)}
      onClick={handleClick}
      active={!!interactionPolicy}
    />
  );
};

export { InteractionPolicyButton as default };
